import { ASPECT, MARK, VIEW_BOX } from './mark.js';

export interface LogoProps extends Omit<React.SVGAttributes<SVGSVGElement>, 'width' | 'height'> {
  /** Rendered HEIGHT in px. Width follows the mark's own proportion — see `ASPECT`. */
  size?: number;
}

/**
 * The ProManage mark: a figure standing beneath an arch. `currentColor` so it can sit on the
 * accent square in the rail, white on a dark surface, or ink on paper — never a second hardcoded
 * brand hex to keep in sync with `--accent`.
 *
 * On an accent tile, give it ~70% of the tile's height. A nav icon takes 50% of its 40px rail
 * target (DESIGN_SYSTEM §5), but this is knocked out of a filled square with nothing beside it
 * to crowd, and a portrait mark wants more side margin than top and bottom.
 */
export function Logo({ size = 24, className, ...rest }: LogoProps) {
  return (
    <svg
      width={size * ASPECT}
      height={size}
      viewBox={VIEW_BOX}
      fill="currentColor"
      fillRule="nonzero"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      <path d={MARK} />
    </svg>
  );
}
